import React, { Component } from "react";
import Checkbox from "material-ui/Checkbox";
import * as Colors from "../../utils/Color";
import { Field } from "react-form";
import { validate } from "../../utils/validation";

const defaultStyles = {
  labelStyles: {
    fontWeight: "bold",
    marginLeft: "7px",
    fontSize: "14px",
    width: "100%"
  },
  uncheckedIconColor: {
    fill: Colors.primary,
    marginRight: 0
  },
  parentElement: {
    width: null,
    display: "inline-block"
  }
};

const headingStyles = {
  labelStyles: {
    fontWeight: "bold",
    marginLeft: "7px",
    fontSize: "16px",
    width: "auto"
  },
  uncheckedIconColor: {
    fill: Colors.primary,
    marginRight: 0
  },
  parentElement: {
    width: null,
    display: "block",
    padding: "12px 20px 0"
  }
};

class CheckboxElement extends Component {
  state = {
    checked: false
  };

  componentDidMount() {
    if (this.props.defaultValue && this.props.formApi) {
      this.props.formApi.setValue(this.props.field, this.props.defaultValue);
      this.setState({ checked: this.props.defaultValue });
    }
  }
  componentDidUpdate(prevProps, nextState) {
    if (prevProps.inputChecked !== this.props.inputChecked) {
      this.setState({ checked: this.props.inputChecked });
    }
  }
  render() {
    let validations;
    if (this.props.field.indexOf("tags") !== -1 && this.props.formApi) {
      validations = {
        validate: value => {
          const values = { ...this.props.formApi.values };
          values.value = value;
          console.log('values: ', values)
          return validate(values, ["tags"]);
        }
      };
    }

    const styles = this.props.heading ? headingStyles : defaultStyles;
    return (
      <Field {...validations} field={this.props.field}>
        {fieldApi => {
          const { setValue } = fieldApi;
          return (
            <Checkbox
              checked={this.state.checked}
              onCheck={(e, isInputChecked) => {
                this.setState({ checked: isInputChecked });
                setValue(isInputChecked);
              }}
              label={this.props.label}
              style={styles.parentElement}
              value={this.props.value}
              id={this.props.id}
              disabled={this.props.disable}
              labelStyle={styles.labelStyles}
              iconStyle={styles.uncheckedIconColor}
            />
          );
        }}
      </Field>
    );
  }
}

export default CheckboxElement;



// WEBPACK FOOTER //
// ./src/components/UI/Checkbox.js